import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Title: {
    id: 'subtopics_title',
    defaultMessage: 'Sub topics',
  },
  DegreePrograms: {
    id: 'subtopics_degree_programs',
    defaultMessage: 'Degree programs',
  },
  ContinuingEducations: {
    id: 'subtopics_continuing_education',
    defaultMessage: 'Continuing educations',
  },
});
